import { type Dictionary, Reward } from '@/types/reports';

export const getPartnerRewards = (partnerId: number, rewards: Reward[]) => {
  return rewards.filter(reward => reward.partner_id === partnerId);
};

export const getFirstParamsFromDictionary = (dictionary: Dictionary) => {
  const firstPartner = dictionary.partners?.[0];
  const firstPeriod = dictionary.periods?.[0];

  let statuses;
  let rewardStatus;
  let dateRangeType;
  let firstReward = dictionary.rewards?.[0];

  if (firstPartner && dictionary.rewards) {
    const partnerRewards = getPartnerRewards(firstPartner.id, dictionary.rewards);

    firstReward = partnerRewards.length ? partnerRewards[0] : undefined;
  }

  if (dictionary.statuses?.items) {
    const selectedStatuses = dictionary.statuses.items.filter(status => status.selected);

    statuses = selectedStatuses?.map(status => status.key);
  }

  if (dictionary.reward_statuses?.items) {
    const selectedStatuses = dictionary.reward_statuses.items.filter(status => status.selected);

    rewardStatus = selectedStatuses?.map(status => status.key);
  }

  if (dictionary.date_range_type?.items) {
    const selectedStatuses = dictionary.date_range_type.items.filter(status => status.selected);

    dateRangeType = selectedStatuses?.map(status => status.key);
  }

  return {
    partner_id: firstPartner?.id,
    reward_id: firstReward?.id,
    period: firstPeriod || '',
    date_from: firstPeriod?.date_from || null,
    date_to: firstPeriod?.date_to || null,
    statuses,
    rewardStatus,
    dateRangeType,
  };
};

export const getRewards = (partnerId: number | undefined, dictionary: Dictionary) => {
  return dictionary.partners && partnerId !== undefined
    ? getPartnerRewards(partnerId, dictionary.rewards || [])
    : dictionary.rewards;
};

export default getFirstParamsFromDictionary;
